import { createParamContext, makeStringParser } from 'app/components/router/createParamContext';

export const {
  Provider: DmmEnvProvider,
  Consumer: DmmEnvConsumer,
  useParams: useDmmEnv,
} = createParamContext(makeStringParser('dmm_env'));

export type DmmEnvType = string;
